function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M122 163C189.379 163 244 155.613 244 146.5V128.5C244 137.613 189.379 145 122 145C54.6213 145 0 137.613 0 128.5V146.5C0 155.613 54.6213 163 122 163Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M122 163C189.379 163 244 155.613 244 146.5V128.5H122H0V146.5C0 155.613 54.6213 163 122 163Z",
  fill: "url(#paint0_linear)",
  fillOpacity: 0.25
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 128.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 128.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint1_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M122 145C189.379 145 244 137.613 244 128.5C244 128.5 244 127.5 243.5 127.5C238.5 132 224.144 135.187 192 138C155 141.237 113.5 141.864 72.5 140C59.3234 139.401 6.5 135.5 0.500003 127C0 128 0 128.5 0 128.5C0 137.613 54.6213 145 122 145Z",
  fill: "url(#paint2_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M128 141C195.379 141 250 133.613 250 124.5V106.5C250 115.613 195.379 123 128 123C60.6213 123 6 115.613 6 106.5V124.5C6 133.613 60.6213 141 128 141Z",
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M128 141C195.379 141 250 133.613 250 124.5V106.5H128H6V124.5C6 133.613 60.6213 141 128 141Z",
  fill: "url(#paint3_linear)",
  fillOpacity: 0.25
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 128,
  cy: 106.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 128,
  cy: 106.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint4_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M128 123C195.379 123 250 115.613 250 106.5C250 106.5 250 105.5 249.5 105.5C244.5 110 230.144 113.187 198 116C161 119.237 119.5 119.864 78.5 118C65.3234 117.401 12.5 113.5 6.5 105C6 106 6 106.5 6 106.5C6 115.613 60.6213 123 128 123Z",
  fill: "url(#paint5_linear)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M124 118C191.379 118 246 110.613 246 101.5V83.5C246 92.6127 191.379 100 124 100C56.6213 100 2 92.6127 2 83.5V101.5C2 110.613 56.6213 118 124 118Z",
  fill: "currentColor"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M124 118C191.379 118 246 110.613 246 101.5V83.5H124H2V101.5C2 110.613 56.6213 118 124 118Z",
  fill: "url(#paint6_linear)",
  fillOpacity: 0.25
});

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 124,
  cy: 83.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref15 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 124,
  cy: 83.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint7_linear)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M124 100C191.379 100 246 92.6127 246 83.5C246 83.5 246 82.5 245.5 82.5C240.5 87 226.144 90.1874 194 93C157 96.2375 115.5 96.8636 74.5 95C61.3234 94.401 8.5 90.5 2.5 82C2 83 2 83.5 2 83.5C2 92.6127 56.6213 100 124 100Z",
  fill: "url(#paint8_linear)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M127 95.9999C194.379 95.9999 249 88.6126 249 79.4999V61.5C249 70.6127 194.379 78 127 78C59.6213 78 5 70.6127 5 61.5V79.4999C5 88.6126 59.6213 95.9999 127 95.9999Z",
  fill: "currentColor"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M127 95.9999C194.379 95.9999 249 88.6126 249 79.4999V61.5H127H5V79.4999C5 88.6126 59.6213 95.9999 127 95.9999Z",
  fill: "url(#paint9_linear)",
  fillOpacity: 0.25
});

var _ref19 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 127,
  cy: 61.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref20 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 127,
  cy: 61.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint10_linear)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M127 78C194.379 78 249 70.6127 249 61.5C249 61.5 249 60.5 248.5 60.5C243.5 65 229.144 68.1874 197 71C160 74.2375 118.5 74.8636 77.5 73C64.3234 72.401 11.5 68.5 5.5 60C5 61 5 61.5 5 61.5C5 70.6127 59.6213 78 127 78Z",
  fill: "url(#paint11_linear)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M131 70.9999C198.379 70.9999 253 63.6126 253 54.4999V36.5C253 45.6127 198.379 53 131 53C63.6213 53 9 45.6127 9 36.5V54.4999C9 63.6126 63.6213 70.9999 131 70.9999Z",
  fill: "currentColor"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M131 70.9999C198.379 70.9999 253 63.6126 253 54.4999V36.5H131H9V54.4999C9 63.6126 63.6213 70.9999 131 70.9999Z",
  fill: "url(#paint12_linear)",
  fillOpacity: 0.25
});

var _ref24 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 131,
  cy: 36.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref25 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 131,
  cy: 36.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint13_linear)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M131 53C198.379 53 253 45.6127 253 36.5C253 36.5 253 35.5 252.5 35.5C247.5 40 233.144 43.1874 201 46C164 49.2375 122.5 49.8636 81.5 48C68.3234 47.401 15.5 43.5 9.5 35C9 36 9 36.5 9 36.5C9 45.6127 63.6213 53 131 53Z",
  fill: "url(#paint14_linear)"
});

var _ref27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 244,
  y1: 163,
  x2: 118,
  y2: 163,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 137,
  y1: 117,
  x2: 122,
  y2: 139,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: -3.63368e-8,
  y1: 145,
  x2: 244,
  y2: 145,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 250,
  y1: 141,
  x2: 124,
  y2: 141,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 143,
  y1: 95,
  x2: 128,
  y2: 117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.17
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 6,
  y1: 123,
  x2: 250,
  y2: 123,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 246,
  y1: 118,
  x2: 120,
  y2: 118,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 139,
  y1: 72,
  x2: 124,
  y2: 94,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 2,
  y1: 99.9999,
  x2: 246,
  y2: 99.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 249,
  y1: 96,
  x2: 123,
  y2: 96,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 142,
  y1: 50,
  x2: 127,
  y2: 72,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 5,
  y1: 77.9999,
  x2: 249,
  y2: 77.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: 253,
  y1: 71,
  x2: 127,
  y2: 71,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear",
  x1: 146,
  y1: 25,
  x2: 131,
  y2: 47,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear",
  x1: 9,
  y1: 52.9999,
  x2: 253,
  y2: 52.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})));

function Svg5Chip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 163,
    viewBox: "0 0 259 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Chip);
export default __webpack_public_path__ + "static/media/5chip.c3269a68.svg";
export { ForwardRef as ReactComponent };